<template>
  <div class="min-h-screen py-8">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      
      <!-- Header -->
      <div class="mb-8">
        <h1 class="text-3xl font-bold text-slate-900 dark:text-white">Ingest Command Center</h1>
        <p class="mt-2 text-slate-600 dark:text-slate-400">Manage Source-to-Snowflake pipelines, schema evolution, and quality guardrails.</p>
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-4 gap-8">
        
        <!-- Sidebar: Source Tables -->
        <div class="lg:col-span-1 space-y-4">
          <div class="bg-white dark:bg-slate-800 rounded-lg shadow overflow-hidden">
            <div class="p-4 border-b dark:border-slate-700 bg-slate-100 dark:bg-slate-800/50">
              <h3 class="font-semibold text-slate-700 dark:text-slate-200">Source Tables</h3>
            </div>
            <ul class="divide-y divide-slate-200 dark:divide-slate-700">
              <li 
                v-for="table in tables" 
                :key="table.table_name"
                @click="selectedTable = table.table_name"
                class="p-4 cursor-pointer hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors"
                :class="{'bg-indigo-50 dark:bg-indigo-900/20 border-l-4 border-indigo-500': selectedTable === table.table_name}"
              >
                <div class="flex justify-between items-center">
                  <span class="font-medium text-slate-900 dark:text-white">{{ table.table_name }}</span>
                  <span class="text-xs text-slate-500">{{ formatNumber(table.row_count) }} rows</span>
                </div>
                <div class="mt-1 text-xs text-slate-400">
                  Last: {{ new Date(table.last_altered).toLocaleDateString() }}
                </div>
              </li>
            </ul>
          </div>
        </div>

        <!-- Main Content area -->
        <div class="lg:col-span-3 space-y-8">
          
          <!-- Sync Status / Controls -->
          <div class="bg-white dark:bg-slate-800 rounded-lg shadow p-6 flex justify-between items-center">
             <div>
                <h3 class="text-lg font-medium text-slate-900 dark:text-white">Pipeline Status: <span class="text-green-500">Active</span></h3>
                <p class="text-sm text-slate-500">Source: Postgres-Production  →  Dest: Snowflake-Raw</p>
             </div>
             <button class="px-6 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-md font-medium shadow-sm transition-colors">
               Run Incr. Sync
             </button>
          </div>

          <!-- Schema Mapping -->
          <IngestSchemaMapper v-if="selectedTable" :selected-table="selectedTable" />

          <!-- Guardrails -->
          <IngestQualityGuardrails v-if="selectedTable" :selected-table="selectedTable" />
          
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const selectedTable = ref('USERS')

const { data: tables } = await useFetch('/api/mocks/snowflake/tables', {
    transform: (data: any[]) => {
        // filter for interesting tables for demo
        return data.filter(t => ['USERS', 'ORDERS', 'PRODUCTS'].includes(t.table_name))
    }
})

const formatNumber = (num: number) => {
  return new Intl.NumberFormat('en-US', { notation: "compact", compactDisplay: "short" }).format(num);
}
</script>
